import { Component, Input, OnInit } from '@angular/core';
import _ from 'lodash';

@Component({
    selector: 'privacy-consent-status-chip',
    templateUrl: './privacy-consent-status-chip.component.html',
    styleUrls: ['./privacy-consent-status-chip.component.scss'],
    standalone: true
})

export class PrivacyConsentStatusChipComponent implements OnInit {

  @Input({required: true}) status!: string;
  // Optional stable CSS-class token. When the displayed status text has spaces/punctuation
  // (e.g. "Pending - Customer Signature"), pass a styleKey so the chip still styles correctly.
  @Input() styleKey?: string;

  toClass() {
    if (this.styleKey) {
      return _.toLower(this.styleKey.replace(/\s/g, ''));
    }
    return this.status ? _.toLower(this.status.replace(/\s/g, '')) : '';
  }

  constructor() {
  }

  ngOnInit(): void {
  }

}
